import _classCallCheck from "/app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "/app/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "/app/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _defineProperty from "/app/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es.array.concat.js";
import { __decorate } from "tslib";
import { Options, Vue } from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import WIcon from "@/components/wrapper/w-icon.vue";
var Banner = /*#__PURE__*/function (_Vue) {
  function Banner() {
    var _this;
    _classCallCheck(this, Banner);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, Banner, [].concat(args));
    _defineProperty(_this, "type", void 0);
    _defineProperty(_this, "minHeight", void 0);
    _defineProperty(_this, "customIcon", void 0);
    _defineProperty(_this, "closeable", void 0);
    _defineProperty(_this, "isVisible", true);
    return _this;
  }
  _inherits(Banner, _Vue);
  return _createClass(Banner, [{
    key: "icon",
    get: function get() {
      switch (this.type) {
        case 'info':
          return 'information-outline';
        case 'success':
          return 'check-circle-outline';
        case 'error':
          return 'alert-circle-outline';
        case 'warning':
          return 'alert-outline';
        default:
          return 'information-outline';
      }
    }
  }]);
}(Vue);
__decorate([Prop({
  default: "info"
})], Banner.prototype, "type", void 0);
__decorate([Prop({
  default: "64px"
})], Banner.prototype, "minHeight", void 0);
__decorate([Prop()], Banner.prototype, "customIcon", void 0);
__decorate([Prop({
  default: false
})], Banner.prototype, "closeable", void 0);
Banner = __decorate([Options({
  components: {
    WIcon: WIcon
  }
})], Banner);
export default Banner;